<template>
  <div class="dealerships">
    <h1 class="page-title">
      <router-link to="/dealerships">Dealerships</router-link>
      <span class="divider">&rsaquo;</span>
      Create Dealership
    </h1>

    <dealership-form
      :dealership="dealership"
      :form-state="formState"
      :errors="errors"
      @submit="create"
      @revertState="formState = 'normal'"
    ></dealership-form>
  </div>
</template>

<script>
import {mapState} from "vuex";

import dealershipForm from "@/components/dealershipForm/main";
import auth from "@/helpers/auth";

export default {
  components: {dealershipForm},
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return {
      formState: "normal",
      errors: {},
      dealership: {
        id: null,
        dealership_id: "",
        disable: "",
        name: "",
        address_street1: "",
        address_street2: "",
        city: "",
        region: "",
        post_code: "",
        opening_hours: "",
        finance_available: "",
        finance_companies: "",
        all_stock_text: "",
        all_stock_url: "",
        accepts_trade_ins: "",
        latitude: "",
        longitude: "",
        notification_emails: []
      }
    };
  },

  computed: {
    ...mapState({
      dealerships: (state) => state.dealerships.all
    })
  },

  watch: {
    dealerships(all) {
      this.$router.push("/dealerships/" + all[all.length - 1].id);
    }
  },

  methods: {
    create(params) {
      this.formState = "loading";

      this.$store
        .dispatch("createDealership", params)
        .then((resp) => {
          this.formState = "done";
          this.errors = {};
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.formState = "normal";
        });
    }
  }
};
</script>
